import { useRef, useState } from "react";

export function useMentionInput() {
  const [text, setText] = useState("");
  const [mentionOpen, setMentionOpen] = useState(false);
  const [mentionQuery, setMentionQuery] = useState("");
  const inputRef = useRef(null);

  const onTextChange = (e) => {
    if (e.escape) { setMentionOpen(false); return; }
    const v = e.target.value;
    setText(v);
    const upto = v.slice(0, e.target.selectionStart ?? v.length);
    const m = upto.match(/@([\w ]*)$/);
    if (m) { setMentionOpen(true); setMentionQuery(m[1]); } else setMentionOpen(false);
  };

  const insertMention = (u) => {
    setText((t) => t.replace(/@([\w ]*)$/, `@${u.name} `));
    setMentionOpen(false);
    inputRef.current?.focus();
  };

  const resetText = () => setText("");

  return { text, resetText, mentionOpen, mentionQuery, onTextChange, insertMention, inputRef };
}
